import { apiService } from '../../shared/services/apiService';
import { paginationListLimit } from '../../shared/constants/systemConstants';
import {
  FoodScorePageResponse,
  FoodScorePayload,
  FoodScoreType,
} from '../interfaces/FoodScorePageResponse';

const baseUrl = 'api/food-scoring';

const getFoodScoreTypes = async () => {
  const resp = await apiService.get<FoodScoreType[]>(`${baseUrl}/types`);

  return resp.data;
};

const saveFoodScoring = async (foodId: number, scoreResults: FoodScorePayload[]) => {
  const resp = await apiService.put(`${baseUrl}/food/${foodId}`, scoreResults);

  return resp.data;
};

const getWorkingTable = async (page: number) => {
  const params = { limit: paginationListLimit, page };

  const resp = await apiService.get<FoodScorePageResponse>(`${baseUrl}/working-table`, {
    params,
  });

  return resp.data;
};

const getFinalTable = async (page: number) => {
  const params = { limit: paginationListLimit, page };

  const resp = await apiService.get<FoodScorePageResponse>(`${baseUrl}/result-table`, {
    params,
  });

  return resp.data;
};

const deleteFood = async (foodId: number) => {
  const params = { foodId };

  await apiService.post(`${baseUrl}/blacklist`, null, { params });
};

export const foodScoringService = {
  getFoodScoreTypes,
  saveFoodScoring,
  getWorkingTable,
  getFinalTable,
  deleteFood,
};
